import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "toolbar toolbar--fixed",
  style: {"margin-top":"0px","padding-right":"0px","padding-left":"0px","transform":"translateY(0px)"}
}
const _hoisted_2 = {
  class: "toolbar__content",
  style: {"height":"40px"}
}
const _hoisted_3 = {
  class: "toolbar__title",
  style: {"color":"rgb(255, 255, 255)"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "btn__content" }, "ITA", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "btn__content" }, "ENG", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _hoisted_4,
      _createElementVNode("button", {
        type: "button",
        class: "btn btn--large theme--light",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$i18n.locale = 'it'))
      }, _hoisted_6),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn--large theme--light",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$i18n.locale = 'en'))
      }, _hoisted_8)
    ])
  ]))
}